import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import mapUserProductGroup from './mapUserProductGroup';
import UserProductGroup from './UserProductGroup';

export interface Result {
	productGroup: UserProductGroup;
}

export default function findUserProductGroup(client: ApiClient, userId: string, id: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{id}');
	return client
		.fetch(url.expand({ userId, id }))
		.then((response) => response.json())
		.then((response) => ({
			productGroup: mapUserProductGroup(response.productGroup),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
